module.exports = __webpack_public_path__ + "img/invite-font.afacc20d.png";